<header class="hd" [class.is-scrolled]="scrolled()" [class.is-open]="menuOpen()">
  <div class="hd__shell av-container av-container--wide">
    <div class="hd__bar">
      <a
        class="hd__brand"
        [routerLink]="'/' | localePath"
        [attr.aria-label]="'a11y.home' | translate"
      >
        <av-logo variant="primary" [height]="26" [priority]="true" alt="" />
      </a>

      <nav class="hd__nav" [attr.aria-label]="'a11y.mainNav' | translate">
        <ul class="nav">
          @for (link of productGroup().links; track link.href) {
            <li class="nav__item" [attr.data-accent]="link.accent">
              <a
                class="nav__link"
                [routerLink]="link.href"
                routerLinkActive="is-active"
                [ariaCurrentWhenActive]="true"
              >
                <span class="nav__name">
                  <span class="nav__full">{{ link.label }}</span>
                  <span class="nav__short">{{ link.shortLabel ?? link.label }}</span>
                </span>
                <!-- Only the exception is labelled: "available" is the state a
                     product is expected to be in. -->
                @if (link.stage === 'pilot' && link.badge) {
                  <span class="nav__stage t-mono">{{ link.badge }}</span>
                }
              </a>
            </li>
          }
          @if (pricingHref(); as pricing) {
            <li class="nav__item">
              <a class="nav__link" [routerLink]="pricing" routerLinkActive="is-active">
                <span class="nav__name">{{ 'site.header.pricing' | translate }}</span>
              </a>
            </li>
          }
          <li class="nav__item">
            <a class="nav__link" [routerLink]="'/' | localePath" fragment="company">
              <span class="nav__name">{{ 'site.header.company' | translate }}</span>
            </a>
          </li>
        </ul>
      </nav>

      <div class="hd__actions">
        <av-lang-switcher class="hd__lang" />

        <a
          class="hd__login"
          [href]="actions().login.href"
          target="_blank"
          rel="noopener noreferrer"
          (click)="reportLogin()"
          >{{ actions().login.label }}</a
        >

        <av-cta
          class="hd__demo"
          [cta]="actions().demo"
          size="sm"
          [arrow]="false"
          location="header"
          [attr.title]="actions().demoHint"
        />
        <av-cta
          class="hd__start"
          [cta]="actions().start"
          size="sm"
          [arrow]="false"
          location="header"
          [attr.title]="actions().startHint"
        />

        <button
          type="button"
          class="hd__burger"
          [attr.aria-expanded]="menuOpen()"
          aria-controls="hd-menu"
          [attr.aria-label]="(menuOpen() ? 'site.header.close' : 'site.header.menu') | translate"
          (click)="toggleMenu()"
        >
          <av-icon [name]="menuOpen() ? 'close' : 'menu'" [size]="20" />
        </button>
      </div>
    </div>

    <!-- The narrow-screen menu: the same destinations and the same three actions,
         stacked, so nothing on the bar is only reachable at desktop width. -->
    <div
      id="hd-menu"
      class="hd__menu"
      [class.is-open]="menuOpen()"
      [attr.inert]="menuOpen() ? null : ''"
    >
      <ul class="menu__list">
        @for (link of productGroup().links; track link.href) {
          <li [attr.data-accent]="link.accent">
            <a class="menu__link" [routerLink]="link.href" (click)="closeMenu()">
              <span>{{ link.label }}</span>
              @if (link.badge) {
                <span class="pill" [class]="'pill pill--' + link.accent">{{ link.badge }}</span>
              }
            </a>
            @if (link.description) {
              <p class="menu__desc">{{ link.description }}</p>
            }
          </li>
        }
        @if (pricingHref(); as pricing) {
          <li>
            <a class="menu__link" [routerLink]="pricing" (click)="closeMenu()">{{
              'site.header.pricing' | translate
            }}</a>
          </li>
        }
        <li>
          <a
            class="menu__link"
            [routerLink]="'/' | localePath"
            fragment="company"
            (click)="closeMenu()"
            >{{ 'site.header.company' | translate }}</a
          >
        </li>
      </ul>

      <div class="menu__actions">
        <av-cta [cta]="actions().start" block location="header" (click)="closeMenu()" />
        <av-cta
          [cta]="actions().demo"
          block
          [arrow]="false"
          location="header"
          (click)="closeMenu()"
        />
        <a
          class="btn btn--ghost btn--block"
          [href]="actions().login.href"
          target="_blank"
          rel="noopener noreferrer"
          (click)="reportLogin(); closeMenu()"
          >{{ actions().login.label }}</a
        >
        <div class="menu__lang"><av-lang-switcher /></div>
      </div>
    </div>
  </div>
</header>
